module.exports = __webpack_public_path__ + "static/img/14.2eb0b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/14.png
// module id = qHw/
// module chunks = 1